import EditPostTitleForm from "components/forum/EditPostTitleForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "components/ui/Dialog";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "components/ui/Tooltip";
import type { IPostRepliesQuery } from "lib/graphql/queries/engagement/__generated__/PostRepliesQuery.generated";
import useSelfie from "lib/hooks/useSelfie";
import { PencilIcon } from "lucide-react";
import Link from "next/link";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

interface IForumQuestionTitleProps {
  children: React.ReactNode;
  topic: NonNullable<IPostRepliesQuery["postByShortId"]>;
}

export function ForumQuestionTitle({ children, topic }: IForumQuestionTitleProps) {
  const [isEditingTitle, setIsEditingTitle] = useState<boolean>(false);
  const viewer = useSelfie();

  const viewerCanEditTitle = topic.viewerDidAuthor || (viewer && viewer.isSiteAdmin);

  return (
    <div className="col-span-4 space-y-0.5 font-aeonik md:col-span-12">
      <div className="flex items-center space-x-3">
        <h1 className="m-0 text-2xl font-medium lg:text-3xl">{children}</h1>

        {viewerCanEditTitle && (
          <Dialog open={isEditingTitle} onOpenChange={setIsEditingTitle}>
            <DialogTrigger>
              <TooltipProvider delayDuration={0}>
                <Tooltip>
                  <TooltipTrigger asChild={true}>
                    <PencilIcon className="h-5 w-5 text-gray-500 hover:text-brand" />
                  </TooltipTrigger>
                  <TooltipContent
                    side="top"
                    sideOffset={12}
                    className="max-w-xs rounded-xl border border-transparent bg-black text-white"
                  >
                    <strong className="font-bold">
                      <FormattedMessage
                        description="Edição tópico no fórum"
                        defaultMessage="Editar Título"
                        id="XwVj1o"
                      />
                    </strong>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </DialogTrigger>

            <DialogContent className="max-h-screen sm:max-w-[425px] lg:max-w-3xl">
              <DialogHeader>
                <DialogTitle>
                  <FormattedMessage description="Edição tópico no fórum" defaultMessage="Editar Título" id="XwVj1o" />
                </DialogTitle>

                <DialogDescription className="hidden">
                  {topic.__typename === "ForumPost" ? (
                    topic.title
                  ) : (
                    <FormattedMessage defaultMessage="Tópico sem título" id="21oh5H" />
                  )}
                </DialogDescription>
              </DialogHeader>

              <EditPostTitleForm topic={topic} onCancel={() => setIsEditingTitle((prev) => !prev)} />
            </DialogContent>
          </Dialog>
        )}
      </div>

      <Link href="/black/forum" className="flex text-sm font-bold italic text-blue-600 hover:underline">
        ← Voltar
      </Link>
    </div>
  );
}
